import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import './MicroFrontEndEmbed.scss';

// Minimal DOM helpers inlined from reactfoot's utils/dom/dom
function createElementWithAttributes(tag, attributes) {
	const element = document.createElement(tag);
	Object.keys(attributes || {}).forEach((key) => {
		element[key] = attributes[key];
	});
	return element;
}

function createStylesheetElement(attributes) {
	return createElementWithAttributes('link', {
		rel: 'stylesheet',
		...attributes,
	});
}

function createScriptElement(attributes) {
	return createElementWithAttributes('script', {
		type: 'text/javascript',
		...attributes,
	});
}

export const MicroFrontEndEmbed = ({
	id,
	className,
	data,
	scriptURL,
	stylesheetURL,
	onLoad,
	onError,
	config,
}) => {
	useEffect(() => {
		if (config) {
			window.__MFE_CONFIG__ = window.__MFE_CONFIG__ || {};
			window.__MFE_CONFIG__[id] = config;
		}

		const handleOnLoad = () => {
			if (onLoad) onLoad();
		};

		const handleOnError = () => {
			if (onError) onError();
		};

		if (stylesheetURL) {
			const linkEl = createStylesheetElement({
				id: `${id}-stylesheet`,
				href: stylesheetURL,
			});
			document.head.appendChild(linkEl);
		} else {
			handleOnError();
			return;
		}

		const scriptEl = createScriptElement({
			id,
			src: scriptURL,
			onload: handleOnLoad,
			onerror: handleOnError,
			async: true,
			crossorigin: 'anonymous',
		});
		document.body.appendChild(scriptEl);

		return () => {
			if (window.__MFE_CONFIG__ && id in window.__MFE_CONFIG__) {
				delete window.__MFE_CONFIG__[id];
			}
			const el = document.getElementById(id);
			if (el) el.remove();
			const lEl = document.getElementById(`${id}-stylesheet`);
			if (lEl) lEl.remove();
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div
			className={className}
			id={id}
			{...data}
		/>
	);
};

MicroFrontEndEmbed.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string,
	data: PropTypes.object,
	scriptURL: PropTypes.string,
	stylesheetURL: PropTypes.string,
	onLoad: PropTypes.func,
	onError: PropTypes.func,
	config: PropTypes.object,
};

export default MicroFrontEndEmbed;
